

import __layout_0 from '/home/featomato/Documents/Software/katimbo-app/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/Footer.vue'),
'components/NavBarI18n': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/ProjectSwitcher': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/ProjectSwitcher.vue'),
'components/UserProfile': () => import('/home/featomato/Documents/Software/katimbo-app/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
